module.exports = __webpack_public_path__ + "img/s3show@2x.6eb3ede3.png";